import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export function createI18n (lang) {
  return new VueI18n({

    locale: lang,
    messages: {},
    silentTranslationWarn: true
  })
}



// WEBPACK FOOTER //
// ./src/i18n/index.js